import React, { useState, useEffect } from "react";
import { Container, Row, Col, Card, Input, Button, Label } from "reactstrap";
import { connect } from 'react-redux';
import ReactTable from "react-table";
import AmazonProductListingMainPage from "./AmazonProductListingMainPage";
import fetchAsinOptimizationSummaryService from "../../../../Service/OPSServices/AmazonProductListing_v1/fetchAsinOptimizationSummaryService";
import fetchAmazonListingStoreListService from "../../../../Service/OPSServices/AmazonProductListing_v1/fetchAmazonListingStoreListService";
import CustomModal from "../../../Components/Modals/CustomModal";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSync } from "@fortawesome/free-solid-svg-icons";
import { GetMerchantListingsService } from "../../../../Service/OPSServices/GetMerchantListingsService";
import checkAllFeedStatusService from "../../../../Service/OPSServices/AmazonProductListing_v1/checkAllFeedStatusService";
import notify from '../../../../Notifications/ToastifyActions';
import fetchPendingFeedStatusService from "../../../../Service/OPSServices/AmazonProductListing_v1/fetchPendingFeedStatusService";

function AmazonProductListingStore(props) {

  const [storeList, setStoreList] = useState([]);
  const [selectedStore, setSelectedStore] = useState("");
  const [selectedStoreDetails, setSelectedStoreDetails] = useState(null);
  const [searchText, setSearchText] = useState('');
  const [selectedAsin, setSelectedAsin] = useState("");
  const [summaryData, setSummaryData] = useState([]);
  const [loadingSummary, setLoadingSummary] = useState(false);
  const [selectedSku, setSelectedSku] = useState("");
  const [isParentProduct, setIsParentProduct] = useState(false);
  const [refreshing, setRefreshing] = useState(false);
  const [checkingAllFeedsStatus, setCheckingAllFeedsStatus] = useState(false);
  const [pendingFeedStatusData, setPendingFeedStatusData] = useState([]);
  const [loadingPendingFeedStatus, setLoadingPendingFeedStatus] = useState(false);
  const [expandedJson, setExpandedJson] = useState({});
  const [pendingFeedSearch, setPendingFeedSearch] = useState("");
  useEffect(() => {
    fetchAmazonListingStoreListService(props.token).then((res) => {
      if (res && res.storeList) {
        setStoreList(res.storeList);
      }
    });
  }, [props.token]);
  useEffect(() => {
    fetchPendingFeedStatus();
  }, []);

  const toggleJsonExpand = (key) => {
    setExpandedJson((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const fetchPendingFeedStatus = async (showLoading = true) => {
    if (showLoading) setLoadingPendingFeedStatus(true);

    try {
      const res = await fetchPendingFeedStatusService(props.token);

      if (res && res.pendingFeedStatusData) {
        setPendingFeedStatusData(res.pendingFeedStatusData);
      }
    } catch (err) {
      console.log(err);
    } finally {
      if (showLoading) setLoadingPendingFeedStatus(false);
    }
  };

  const renderInputOutputJSON = (data, isRoot = true) => {
    if (data === null || data === undefined) return "-";

    if (typeof data !== "object") return <span>{String(data)}</span>;

    const ulStyle = isRoot
      ? { listStyleType: "none", padding: 0, margin: 0, fontSize: "12px", textAlign: "left" }
      : { listStyleType: "none", paddingLeft: "12px", margin: 0 };

    if (Array.isArray(data)) {
      return (
        <ul style={ulStyle}>
          {data.map((item, index) => (
            <li key={index} style={{ marginBottom: "4px" }}>
              {renderInputOutputJSON(item, false)}
            </li>
          ))}
        </ul>
      );
    }

    return (
      <ul style={ulStyle}>
        {Object.entries(data).map(([key, value]) => (
          <li key={key} style={{ marginBottom: "2px", wordBreak: "break-word" }}>
            <span style={{ fontWeight: "600", color: "#333" }}>{key} : </span>
            {renderInputOutputJSON(value, false)}
          </li>
        ))}
      </ul>
    );
  };

  const filteredPendingFeedData = pendingFeedStatusData.filter((row) => {
    const text = pendingFeedSearch.toLowerCase();
    return (
      (row.storeName || "").toLowerCase().includes(text) ||
      (row.sku || "").toLowerCase().includes(text) ||
      (row.status || "").toLowerCase().includes(text) ||
      (row.mode || "").toLowerCase().includes(text) ||
      (row.asin || "").toLowerCase().includes(text)

    );
  });
  const pendingFeedStatusColumns = [
    {
      Header: "Store Name",
      accessor: "storeName",
      width: 230,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-start w-100" title={value || "-"}>
          <p className="mb-0" style={{
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "200px"
          }}>{value || "-"}</p>
        </div>
      ),
    },
    {
      Header: "ASIN",
      accessor: "asin",
      width: 130,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-start w-100">
          <p className="mb-0">{value || "-"}</p>
        </div>
      ),
    },
    {
      Header: "SKU",
      accessor: "sku",
      width: 180,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-start w-100">
          <p className="mb-0">{value || "-"}</p>
        </div>
      ),
    },
    {
      Header: "Input JSON",
      accessor: "inputJson",
      width: 230,
      Cell: (cellInfo) => {
        const cellKey = `input-${cellInfo.index}`;
        const isExpanded = expandedJson[cellKey];
        const showButton = cellInfo.value && JSON.stringify(cellInfo.value).length > 80;

        return (
          <div className="d-flex flex-column justify-content-start w-100 text-left">
            <div style={{ maxHeight: isExpanded ? "none" : "89px", overflow: "hidden" }}>
              {cellInfo.value ? renderInputOutputJSON(cellInfo.value) : "-"}
            </div>
            {showButton && (
              <span
                onClick={() => toggleJsonExpand(cellKey)}
                style={{ color: "#3D85C6", cursor: "pointer", fontSize: "11px", fontWeight: "bold", marginTop: "4px" }}
              >
                {isExpanded ? "Read Less" : "...Read More"}
              </span>
            )}
          </div>
        );
      },
    },
    {
      Header: "Output JSON",
      accessor: "outputJson",
      width: 230,
      Cell: (cellInfo) => {
        const cellKey = `output-${cellInfo.index}`;
        const isExpanded = expandedJson[cellKey];
        const showButton = cellInfo.value && JSON.stringify(cellInfo.value).length > 80;

        return (
          <div className="d-flex flex-column justify-content-start w-100 text-left">
            <div style={{ maxHeight: isExpanded ? "none" : "89px", overflow: "hidden" }}>
              {cellInfo.value ? renderInputOutputJSON(cellInfo.value) : "-"}
            </div>
            {showButton && (
              <span
                onClick={() => toggleJsonExpand(cellKey)}
                style={{ color: "#3D85C6", cursor: "pointer", fontSize: "11px", fontWeight: "bold", marginTop: "4px" }}
              >
                {isExpanded ? "Read Less" : "...Read More"}
              </span>
            )}
          </div>
        );
      },
    },
    {
      Header: "Status",
      accessor: "status",
      width: 140,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0">{value || "-"}</p>
        </div>
      ),
    },
    {
      Header: "Mode",
      accessor: "mode",
      width: 100,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0">{value || "-"}</p>
        </div>
      ),
    },
    {
      Header: "Created At",
      accessor: "createdAt",
      width: 130,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0">{value || "-"}</p>
        </div>
      ),
    },
    // {
    //   Header: "Updated On",
    //   accessor: "updatedOn",
    //   width: 130,
    //   Cell: ({ value }) => (
    //     <div className="d-flex justify-content-center w-100">
    //       <p className="mb-0">{value || "-"}</p>
    //     </div>
    //   ),
    // },
  ];
  const handleStoreChange = async (e) => {
    const storeId = Number(e.target.value);
    setSelectedStore(storeId);
    setSummaryData([]);
    setSearchText("");

    const store = storeList.find((s) => s.id === storeId);
    setSelectedStoreDetails(store || null);
    if (store && store.integerID) {
      setLoadingSummary(true);
      const data = {
        integerID: store.integerID
      }
      const res = await fetchAsinOptimizationSummaryService(props.token, data);
      if (res && res.summaryList) {
        console.log(res)
        setSummaryData(res.summaryList);
      }
      setLoadingSummary(false);
    }
  };

  const filteredSummaryData = summaryData.filter((row) => {
    const text = searchText.toLowerCase();
    return (
      (row.Asin || "").toLowerCase().includes(text) ||
      String(row.IntegerId || "").includes(text) || String(row.productTitle || "").toLowerCase().includes(text) || String(row.Sku || "").toLowerCase().includes(text) ||
      String(row.isParentProduct ? "yes" : "no").toLowerCase().includes(text)
    );
  });


  const handleSkuClick = (product) => {
    if (!selectedStoreDetails) return;

    setSelectedAsin(product.Asin);
    setIsParentProduct(product.isParentProduct);

    setSelectedSku(product.Sku || "");
  };
  const handleCheckAllFeedStatus = async () => {
    setCheckingAllFeedsStatus(true);
    notify.NotifySuccess("Backend job for feed update submitted successfully.");

    try {
      await checkAllFeedStatusService(props.token);
    } catch (err) {
      console.log(err);
    }
  };

  const columns = [
    // {
    //   Header: "Integer ID",
    //   accessor: "IntegerId",
    //   width: 180,
    //   Cell: ({ value }) => (
    //     <div className="d-flex justify-content-center w-100">
    //       <p className="mb-0">{value}</p>
    //     </div>
    //   ),
    // },
    {
      Header: "ASIN",
      accessor: "Asin",
      width: 140,
      Cell: (cellInfo) => {
        return (
          <div className="d-flex justify-content-center w-100">
            <p className='mb-0'>{cellInfo.value}</p>
          </div>
        );
      },
    },
    {
      Header: "SKU",
      accessor: "Sku",
      width: 258,
      Cell: (cellInfo) => (
        <div className="d-flex justify-content-center w-100">
          <p
            className='mb-0'
            style={{
              cursor: cellInfo.value ? "pointer" : "default",
              textDecoration: cellInfo.value ? "underline" : "none",
              color: cellInfo.value ? "blue" : "inherit",
            }}
            onClick={() => {
              if (cellInfo.value) {
                handleSkuClick(cellInfo.row._original);
              }
            }}
          >
            {cellInfo.value || "-"}
          </p>
        </div>
      ),
    },
    {
      Header: "IsParent",
      accessor: "isParentProduct",
      width: 100,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-center w-100">
          <p className='mb-0'>{value ? "Yes" : "No"}</p>
        </div>
      ),
    },
    {
      Header: "Product Title",
      accessor: "productTitle",
      width: 484,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-start w-100">
          <p className="mb-0">{value}</p>
        </div>
      ),
    },
    {
      Header: "Total",
      accessor: "TotalFieldsCounts",
      width: 100,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0">{value !== null && value !== undefined ? value : "-"}</p>
        </div>
      ),
    },
    // {
    //   Header: "Fields",
    //   accessor: "Fields",
    //   width: 100,
    //   Cell: ({ value }) => (
    //     <div className="d-flex justify-content-center w-100">
    //       <p className="mb-0">{value !== null && value !== undefined ? value : "-"}</p>
    //     </div>
    //   ),
    // },
    {
      Header: "Mandatory",
      accessor: "MandatoryFieldCounts",
      width: 100,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0">{value !== null && value !== undefined ? value : "-"}</p>
        </div>
      ),
    },
    {
      Header: "Valid",
      accessor: "ValidFieldsCounts",
      width: 100,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0">
            {value ? value : "-"}
          </p>
        </div>
      ),
    },
    // {
    //   Header: "Basic",
    //   accessor: "BasicFieldCounts",
    //   width: 100,
    //   Cell: ({ value }) => (
    //     <div className="d-flex justify-content-center w-100">
    //       <p className="mb-0">{value !== null && value !== undefined ? value : "-"}</p>
    //     </div>
    //   ),
    // },
    {
      Header: "Missing",
      accessor: "MissingFieldCounts",
      width: 100,
      Cell: ({ value }) => (
        <div className="d-flex justify-content-center w-100">
          <p className="mb-0">
            {value ? value : "-"}
          </p>
        </div>
      ),
    },
    // {
    //   Header: "Errors",
    //   accessor: "ErrorsFieldCounts",
    //   width: 100,
    //   Cell: ({ value }) => (
    //     <div className="d-flex justify-content-center w-100">
    //       <p className="mb-0">
    //       {value?value:"-"}
    //       </p>
    //     </div>
    //   ),
    // },
    // {
    //   Header: "Warnings",
    //   accessor: "WarningFieldCounts",
    //   width: 100,
    //   Cell: ({ value }) => (
    //     <div className="d-flex justify-content-center w-100">
    //       <p className="mb-0">
    //       {value?value:"-"}
    //       </p>
    //     </div>
    //   ),
    // },


  ];

  if (selectedSku) {
    return (
      <AmazonProductListingMainPage
        asin={selectedAsin}
        sku={selectedSku}
        storeDetails={selectedStoreDetails}
        isParentProduct={isParentProduct}
        // onBack={() => setSelectedAsin("")}
        onBack={() => setSelectedSku("")}
        setSummaryData={setSummaryData}
        selectedStore={selectedStoreDetails && selectedStoreDetails.integerID}
        setSelectedAsin={setSelectedAsin}
        setSelectedSku={setSelectedSku}
        setIsParentProduct={setIsParentProduct}
      />
    );
  }
  const getMerchantListingsForSellerPartnerID = async () => {
    setRefreshing(true);

    try {
      let data = { id: selectedStoreDetails && selectedStoreDetails.stringID }

      const res = await GetMerchantListingsService(props.token, data);

      console.log(res);
    } catch (err) {
      console.log(err);
    } finally {
      setRefreshing(false);
    }
  };
  return (
    <>
      <Container>
        <Row className="mt-5">

          <Col md={12} className="mt-2 mb-2 mt-5">
            <h4>Amazon Listing : Store Selection </h4>
          </Col>

          <Col md={12} className="ml-1 mr-4">
            <Card className="p-4">

              <Row className="mb-3 align-items-center">
                <Col md={6}>
                  <Row className="align-items-center">
                    <Col md={2} className="amazon-listing-labels mb-0">
                      Store :
                    </Col>
                    <Col md={10}>
                      <Input
                        type="select"
                        className="w-75"

                        value={selectedStore}
                        onChange={handleStoreChange}
                      >
                        <option value="">-- Select Store --</option>
                        {storeList && storeList.map((store) => (
                          <option key={store.id} value={store.id}>
                            {store.name}
                          </option>
                        ))}
                      </Input>
                    </Col>

                  </Row>

                </Col>
                <Col md={6}>
                  {!selectedStoreDetails && (
                    <div className='d-flex justify-content-end align-items-center gap-2'>
                      <Button
                        className="btn-background-color mr-2"
                        onClick={handleCheckAllFeedStatus}
                        disabled={
                          checkingAllFeedsStatus ||
                          pendingFeedStatusData.length === 0
                        }
                      >
                        {checkingAllFeedsStatus ? "Update Feeds" : "Update Feeds"}
                      </Button>
                      <Input
                        className="w-50"
                        value={pendingFeedSearch}
                        onChange={(e) => setPendingFeedSearch(e.target.value)}
                        placeholder="Search..."
                      />

                    </div>
                  )}
                  {selectedStoreDetails && (
                    <>
                      <div className="d-flex justify-content-end align-items-center">
                        <Button
                          className="btn-background-color mr-2"
                          onClick={getMerchantListingsForSellerPartnerID}
                          disabled={refreshing}
                          title="Refresh"
                          style={{ padding: "6px 12px" }}
                        >
                          <FontAwesomeIcon
                            icon={faSync}
                            spin={refreshing}
                            style={{ fontSize: "14px" }}
                          />
                        </Button>
                        <Input
                          className="w-50"
                          value={searchText}
                          onChange={(e) => setSearchText(e.target.value)}
                          placeholder="Search Product....."
                        />
                      </div>
                    </>)}
                </Col>

              </Row>
              {!selectedStoreDetails && (
                <Row>
                  <Col md={12}>
                    <h5 className="mb-3 mt-3">
                      <b>Pending Feed Status</b>
                    </h5>

                    <ReactTable
                      data={filteredPendingFeedData}
                      columns={pendingFeedStatusColumns}
                      loading={loadingPendingFeedStatus}
                      className="-fixed -highlight -striped"
                      defaultPageSize={10}
                      noDataText={
                        loadingPendingFeedStatus
                          ? "Loading Pending Feeds..."
                          : "No Pending Feeds Found."
                      }
                      getTheadProps={() => ({
                        style: {
                          overflowY: "hidden",
                          background: "#B1FA63",
                          color: "#243837",
                        },
                      })}
                    />
                  </Col>
                </Row>
              )}
              {selectedStoreDetails && (
                <>
                  {/* <Row className="mt-4 mb-2">
                  <Col md={4}>
                    <p className="mb-0"><b>Seller ID</b></p>
                    <p>{selectedStoreDetails.stringID}</p>
                  </Col>
                  <Col md={4}>
                    <p className="mb-0"><b>Marketplace ID</b></p>
                    <p>{selectedStoreDetails.marketplaceStringId}</p>
                  </Col>
                  <Col md={4}>
                    <p className="mb-0"><b>Currency</b></p>
                    <p>{selectedStoreDetails.currencyCode}</p>
                  </Col>
                </Row> */}

                  <Row>

                    <Col md={12}>
                      <ReactTable
                        data={filteredSummaryData}
                        columns={columns}
                        loading={loadingSummary}
                        className="-fixed -highlight -striped mt-2"
                        getTheadProps={() => ({
                          style: {
                            overflowY: "hidden",
                            background: "#B1FA63",
                            color: "#243837",
                          },
                        })}
                        defaultPageSize={10}
                        noDataText={loadingSummary ? "Loading Data..." : "No Data Found."}
                      />
                    </Col>
                  </Row>
                </>)}

            </Card>
          </Col>



        </Row>
      </Container>
    </>
  );
}

const mapStateToProps = state => ({
  token: state.loggedUser.token,
  accessLevel: state.loggedUser.accessLevel,
  status: state.loggedUser.status,
});

export default connect(mapStateToProps)(AmazonProductListingStore);